var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRemove = function SvgIconRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B84D7",
    d: "M12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8m2.1 4.5L12 10.6 9.9 8.5 8.5 9.9l2.1 2.1-2.1 2.1 1.4 1.4 2.1-2.1 2.1 2.1 1.4-1.4-2.1-2.1 2.1-2.1z"
  })));
};
export { SvgIconRemove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMiA0YzQuNCAwIDggMy42IDggOHMtMy42IDgtOCA4LTgtMy42LTgtOCAzLjYtOCA4LTh6bTIuMSA0LjVMMTIgMTAuNiA5LjkgOC41IDguNSA5LjlsMi4xIDIuMS0yLjEgMi4xIDEuNCAxLjQgMi4xLTIuMSAyLjEgMi4xIDEuNC0xLjQtMi4xLTIuMSAyLjEtMi4xLTEuNC0xLjR6IiBmaWxsPSIjOEI4NEQ3IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KPC9zdmc+Cg==";